// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linked-orders-outer-wrapper{width:100%;margin-top:10px}.linked-orders-outer-wrapper .icon-button-style{padding:0 3px;margin-right:5px}.linked-orders-outer-wrapper .icon-style{color:#444}\n", ""]);
// Exports
module.exports = exports;
